module.exports = __webpack_public_path__ + "img/Embers-Adrift-2022-009.497e2333.jpg";